import { css } from 'styled-components';

const variables = css`
  :root {
    /* White & Black Japanese Color System */
    --bg-primary: #FFFFFF;
    --bg-secondary: #FAFAFA;
    --bg-tertiary: #F5F5F5;
    --bg-elevated: #FFFFFF;
    
    --text-primary: #000000;
    --text-secondary: #1A1A1A;
    --text-tertiary: #4A4A4A;
    --text-muted: #808080;
    
    /* Japanese Accent Colors - Black for emphasis */
    --accent-primary: #000000;
    --accent-secondary: #1A1A1A;
    --accent-gold: #D4AF37;
    --accent-sakura: #FFB7C5;
    
    /* Semantic Colors */
    --border-color: rgba(0, 0, 0, 0.1);
    --border-hover: rgba(0, 0, 0, 0.3);
    --shadow-sm: rgba(0, 0, 0, 0.08);
    --shadow-md: rgba(0, 0, 0, 0.12);
    --shadow-lg: rgba(0, 0, 0, 0.16);
    --shadow-accent: rgba(0, 0, 0, 0.1);
    
    /* Legacy Support */
    --dark-navy: var(--bg-tertiary);
    --navy: var(--bg-primary);
    --light-navy: var(--bg-elevated);
    --lightest-navy: var(--bg-elevated);
    --navy-shadow: var(--shadow-lg);
    --dark-slate: var(--text-muted);
    --slate: var(--text-secondary);
    --light-slate: var(--text-secondary);
    --lightest-slate: var(--text-primary);
    --white: var(--bg-primary);
    --green: var(--accent-primary);
    --green-tint: rgba(0, 0, 0, 0.05);
    --japanese-red: var(--accent-primary);
    --japanese-vermillion: var(--accent-primary);
    --japanese-gold: var(--accent-gold);
    --japanese-sakura: var(--accent-sakura);

    /* Modern Typography System */
    --font-display: 'Calibre', -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
    --font-body: 'Calibre', -apple-system, 'BlinkMacSystemFont', 'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif;
    --font-mono: 'SF Mono', 'Monaco', 'Inconsolata', 'Fira Code', 'Fira Mono', 'Droid Sans Mono', monospace;
    --font-japanese: 'Hiragino Sans', 'Yu Gothic', 'Meiryo', 'Noto Sans JP', sans-serif;

    /* Type Scale - Bold & Dramatic */
    --fz-xs: 11px;
    --fz-sm: 13px;
    --fz-md: 16px;
    --fz-lg: 18px;
    --fz-xl: 20px;
    --fz-xxl: 24px;
    --fz-heading-sm: 32px;
    --fz-heading: 48px;
    --fz-heading-lg: 64px;
    --fz-hero: clamp(80px, 18vw, 200px);
    --fz-hero-sub: clamp(24px, 4vw, 36px);
    --fz-bg-text: clamp(100px, 20vw, 300px);

    /* Spacing System */
    --space-xs: 4px;
    --space-sm: 8px;
    --space-md: 16px;
    --space-lg: 24px;
    --space-xl: 32px;
    --space-2xl: 48px;
    --space-3xl: 64px;
    --space-4xl: 96px;
    --space-5xl: 128px;

    /* Layout */
    --border-radius: 0px;
    --border-radius-sm: 2px;
    --border-radius-md: 4px;
    --border-radius-lg: 8px;
    
    --nav-height: 80px;
    --nav-scroll-height: 60px;
    --container-width: 1400px;
    --container-padding: clamp(32px, 6vw, 120px);

    /* Transitions */
    --transition-fast: 150ms cubic-bezier(0.4, 0, 0.2, 1);
    --transition-base: 250ms cubic-bezier(0.4, 0, 0.2, 1);
    --transition-slow: 400ms cubic-bezier(0.4, 0, 0.2, 1);
    --transition: var(--transition-base);
    --easing: cubic-bezier(0.4, 0, 0.2, 1);

    /* Z-Index Scale */
    --z-base: 1;
    --z-dropdown: 100;
    --z-sticky: 200;
    --z-fixed: 300;
    --z-modal: 400;
    --z-popover: 500;
    --z-tooltip: 600;

    /* Hamburger Menu */
    --hamburger-width: 28px;
    --ham-before: top 0.1s ease-in 0.25s, opacity 0.1s ease-in;
    --ham-before-active: top 0.1s ease-out, opacity 0.1s ease-out 0.12s;
    --ham-after: bottom 0.1s ease-in 0.25s, transform 0.22s cubic-bezier(0.55, 0.055, 0.675, 0.19);
    --ham-after-active: bottom 0.1s ease-out, transform 0.22s cubic-bezier(0.215, 0.61, 0.355, 1) 0.12s;
  }
`;

export default variables;
